import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { X, Plus } from "lucide-react";
import { useLang } from "../lang";
import { useCompare } from "./CompareContext";
import ComparePicker from "./ComparePicker";
import { productsBySlugs, MAX_COMPARE } from "../compare";
import { isRender } from "../catalog";

export default function CompareBar() {
  const { lang } = useLang();
  const { slugs, remove, clear } = useCompare();
  const { pathname } = useLocation();
  const [picker, setPicker] = useState(false);
  if (!slugs.length || pathname === "/confronta") return null;
  const items = productsBySlugs(slugs);
  const ready = items.length >= 2;

  return (
    <>
      <div
        className="fixed z-[55] left-3 right-3 bottom-[76px] md:bottom-6 md:left-1/2 md:right-auto md:-translate-x-1/2 md:w-auto bg-white/95 backdrop-blur-xl border border-black/10 rounded-2xl shadow-[0_20px_50px_-15px_rgba(0,0,0,0.3)] p-2.5 md:p-3 flex items-center gap-2 md:gap-3"
        data-testid="compare-bar"
      >
        <div className="flex items-center gap-2 min-w-0">
          {items.map((p) => (
            <div key={p.slug} className="relative w-12 h-10 md:w-14 md:h-11 rounded-lg bg-white border border-[#e4e4e7] flex-shrink-0" title={p[lang].name}>
              <img src={p.image} alt={p[lang].name} className={`w-full h-full rounded-lg ${isRender(p.image) ? "object-contain p-1" : "object-cover"}`} />
              <button
                type="button"
                onClick={() => remove(p.slug)}
                className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-[#1d1d1f] text-white flex items-center justify-center"
                aria-label="Rimuovi"
                data-testid={`compare-bar-remove-${p.slug}`}
              >
                <X size={11} />
              </button>
            </div>
          ))}
          {items.length < MAX_COMPARE && (
            <button
              type="button"
              onClick={() => setPicker(true)}
              className="w-12 h-10 md:w-14 md:h-11 rounded-lg border border-dashed border-[#1D3F94]/40 text-[#1D3F94] flex items-center justify-center flex-shrink-0 hover:bg-[#1D3F94]/5 transition-colors"
              aria-label={lang === "it" ? "Aggiungi sistema" : "Add system"}
              data-testid="compare-bar-add"
            >
              <Plus size={16} />
            </button>
          )}
        </div>
        <div className="flex items-center gap-1 md:gap-2 ml-auto">
          <button type="button" onClick={clear} className="text-[13px] text-[#6e6e73] hover:text-[#1d1d1f] px-2" data-testid="compare-bar-clear">
            {lang === "it" ? "Svuota" : "Clear"}
          </button>
          {ready ? (
            <Link to="/confronta" className="btn-pill btn-primary whitespace-nowrap !py-2 !px-4 text-[14px]" data-testid="compare-bar-go">
              {lang === "it" ? `Confronta (${items.length})` : `Compare (${items.length})`}
            </Link>
          ) : (
            <button type="button" onClick={() => setPicker(true)} className="btn-pill btn-primary whitespace-nowrap !py-2 !px-4 text-[14px]" data-testid="compare-bar-go">
              {lang === "it" ? "Aggiungi" : "Add"} <Plus size={14} className="ml-1" />
            </button>
          )}
        </div>
      </div>
      <ComparePicker open={picker} onClose={() => setPicker(false)} />
    </>
  );
}
